import Keycloak, { KeycloakTokenParsed } from 'keycloak-js';
import { AuthProvider } from 'react-admin';
import { jwtDecode } from "jwt-decode";

export type PermissionsFunction = (decoded: KeycloakTokenParsed) => any;

export const keycloakAuthProvider = (
    client: Keycloak,
    options: {
        onPermissions?: PermissionsFunction;
        loginRedirectUri?: string;
        logoutRedirectUri?: string;
    } = {}
): AuthProvider => ({
    async login() {
        return client.login({
            redirectUri: options.loginRedirectUri ?? window.location.origin,
        });
    },
    async logout() {
        return client.logout({
            redirectUri: options.logoutRedirectUri ?? window.location.origin,
        });
    },
    async checkError() {
        return Promise.resolve();
    },
    async checkAuth() {
        if (!client.authenticated || !client.token) {
            return Promise.reject('Failed to obtain access token.');
        }
        return Promise.resolve();
    },
    async getPermissions() {
        if (!client.token) {
            return Promise.resolve(false);
        }
        const decoded = jwtDecode<KeycloakTokenParsed>(client.token);
        return Promise.resolve(
            options.onPermissions ? options.onPermissions(decoded) : decoded
        );
    },
    async getIdentity() {
        if (client.token) {
            const decoded = jwtDecode<KeycloakTokenParsed>(client.token);
            const id = decoded.sub || '';
            const fullName = decoded.name || '';
            const branch
                = decoded.organization
                || '';
            const roles = decoded.resource_access?.account?.roles ?? [];
            const isGroupAdmin = roles.includes('group-admin');
            const isOrgAdmin = roles.includes('org-admin');
            const isScheduler = roles.includes('scheduler');
            const isFinancial = roles.includes('financial');
            if (!branch
            ) {
                window.location.href = '/apply-group.html';
                return Promise.reject(new Error('请先联系管理员进行分公司及部分授权'));
            }
            return Promise.resolve({
                id, fullName, branch, isGroupAdmin, isOrgAdmin, isScheduler, isFinancial
            });
        }
        return Promise.reject('Failed to get identity.');
    },
});
